/**
 * Parse/format Braze QA date strings for MUI DatePicker wire values.
 * @module braze-configuration/date-field-format
 */

import { format, isValid, parse } from 'date-fns'

export type BrazeDateWireFormat = 'yyyy-MM-dd' | 'MM-dd-yyyy'

const ISO_DATE_PATTERN = 'yyyy-MM-dd'
const GIFT_DATE_PATTERN = 'MM-dd-yyyy'

function patternForFormat (wireFormat: BrazeDateWireFormat): string {
  return wireFormat === 'MM-dd-yyyy' ? GIFT_DATE_PATTERN : ISO_DATE_PATTERN
}

/**
 * @returns Calendar date for the picker, or null when empty/invalid.
 */
export function parseBrazeDateString (
  value: unknown,
  wireFormat: BrazeDateWireFormat = ISO_DATE_PATTERN,
): Date | null {
  const trimmed = String(value ?? '').trim()
  if (!trimmed) {
    return null
  }
  const pattern = patternForFormat(wireFormat)
  const parsed = parse(trimmed, pattern, new Date())
  if (!isValid(parsed)) {
    return null
  }
  return parsed
}

/**
 * @returns Wire string for APIs and form state.
 */
export function formatBrazeDateString (
  date: Date | null | undefined,
  wireFormat: BrazeDateWireFormat = ISO_DATE_PATTERN,
): string {
  if (!date || !isValid(date)) {
    return ''
  }
  const pattern = patternForFormat(wireFormat)
  return format(date, pattern)
}
